var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdateMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3955_43716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.2996 0H2.96602C1.32793 0 0 1.32793 0 2.96602V32.848C0 34.4861 1.32793 35.814 2.96602 35.814H49.2996C50.9377 35.814 52.2656 34.4861 52.2656 32.848V2.96602C52.2656 1.32793 50.9377 0 49.2996 0Z",
    fill: "#E57E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0642 35.1811C51.4384 34.8951 51.7415 34.5265 51.9501 34.1042C52.1586 33.6819 52.267 33.2172 52.2666 32.7462V3.06785C52.2666 2.25421 51.9434 1.47389 51.3681 0.898553C50.7928 0.323219 50.0124 0 49.1988 0L19.5137 0L51.001 35.1579L51.0642 35.1811Z",
    fill: "#F29C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.753 0H3.06785C2.25421 0 1.47389 0.323219 0.898554 0.898553C0.32322 1.47389 7.75376e-07 2.25421 7.75376e-07 3.06785V32.7462C-0.000324341 33.203 0.101596 33.6541 0.298288 34.0664C0.494981 34.4788 0.781459 34.8419 1.13672 35.1291L1.26563 35.1579L32.753 0Z",
    fill: "#F29C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1978 0H3.06785C2.25421 0 1.47389 0.323219 0.898553 0.898553C0.323219 1.47389 0 2.25421 0 3.06785L0 4.24711L22.1386 19.5022C23.3133 20.3117 24.7062 20.7452 26.1328 20.7452C27.5594 20.7452 28.9523 20.3117 30.127 19.5022L52.2656 4.24711V3.06785C52.2656 2.25421 51.9424 1.47389 51.3671 0.898553C50.7917 0.323219 50.0114 0 49.1978 0Z",
    fill: "#F0C419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6088 60.0017C13.4165 60.0018 13.2289 59.9428 13.0713 59.8326C12.9137 59.7224 12.7938 59.5665 12.7278 59.3859C12.6618 59.2053 12.653 59.0087 12.7025 58.8229C12.752 58.6371 12.8574 58.471 13.0045 58.3472L25.964 47.5758C26.0578 47.4937 26.167 47.4312 26.2852 47.3918C26.4034 47.3524 26.5283 47.337 26.6525 47.3465C26.7768 47.3559 26.8979 47.39 27.0088 47.4468C27.1197 47.5036 27.2182 47.582 27.2984 47.6773C27.3787 47.7726 27.4392 47.8829 27.4763 48.0019C27.5134 48.1208 27.5265 48.246 27.5147 48.37C27.5029 48.494 27.4665 48.6145 27.4076 48.7243C27.3487 48.8341 27.2685 48.9311 27.1717 49.0095L14.2123 59.7813C14.0436 59.9238 13.8297 60.0019 13.6088 60.0017Z",
    fill: "#FF5364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6011 57.9599C24.4103 57.96 24.2241 57.9019 24.0672 57.7934C23.9104 57.6849 23.7903 57.5311 23.7232 57.3526C23.656 57.1741 23.6449 56.9793 23.6913 56.7943C23.7377 56.6093 23.8394 56.4428 23.9829 56.3172L27.173 53.4027C27.2655 53.321 27.3732 53.2584 27.49 53.2184C27.6068 53.1785 27.7303 53.162 27.8535 53.1699C27.9766 53.1778 28.097 53.2099 28.2078 53.2645C28.3185 53.319 28.4173 53.3949 28.4987 53.4877C28.58 53.5805 28.6422 53.6885 28.6817 53.8055C28.7212 53.9224 28.7372 54.046 28.7288 54.1691C28.7204 54.2923 28.6878 54.4125 28.6329 54.523C28.5779 54.6335 28.5016 54.7321 28.4085 54.8131L25.219 57.7275C25.0482 57.8776 24.8285 57.9603 24.6011 57.9599Z",
    fill: "#35ACEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0781 39.4151L33.9927 53.5825L44.7982 37.3728L59.9892 22.8984L28.0781 39.4151Z",
    fill: "#285680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9891 22.793L28.8137 40.9778L19.6406 38.598L59.9891 22.793Z",
    fill: "#7ED0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0096 34.8164L33.9922 53.5787L35.7644 42.8325L49.0096 34.8164Z",
    fill: "#35ACEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.988 22.8983C59.9965 22.8717 60.0078 22.8515 59.988 22.8712L35.7637 42.8362L50.77 46.9211L59.988 22.8983Z",
    fill: "#7ED0FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3955_43716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateMail);
export default __webpack_public_path__ + "static/media/Update_Mail.1c230e4a5b3186c71dcb56386153b6f8.svg";
export { ForwardRef as ReactComponent };